var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch side-menu",class:{'no-notes' : this.notesNumber === 0, 'one-note' : this.notesNumber === 1, 'two-notes' : this.notesNumber === 2, 'more-notes' : this.notesNumber >= 3}},[_c('badge'),_c('mainmenu'),(_vm.user !== null)?_c('topheader'):_vm._e(),(_vm.user !== null)?_c('useredit'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }